import { DataDownloadMessages } from '../types';

export const dataDownloadZHTW: DataDownloadMessages = {
  'app.datadownload.checkbox.study_abroad': 'Study abroad',
  'app.datadownload.checkbox.additional_demographics_info': 'Additional demographics',
  'app.datadownload.checkbox.remove_anonymous_user': 'Remove anonymous users',
}
